import {HISTORY_RECORD_TIME, MAX_HISTORY_CARD_COUNT} from "@/Const";
import {formatDate} from "@/utils";

let mLibraryHistory:any;

export function initLibraryHistory(db:any){
    mLibraryHistory = db.table('libraryHistory')
}

/***********************历史记录******************************/
/**
 * 最新的历史记录的保存时间
 */
const hasBeyondLastestTime = (szId:any)=>{
    return new Promise(async (resolve) => {
        const arrayHistory = await mLibraryHistory.where('libraryId').equals(szId).toArray();
        arrayHistory.sort((a,b)=>{
            return b.historyTime - a.historyTime;
        })

        //只保存最新的10-20个
        if (arrayHistory.length > MAX_HISTORY_CARD_COUNT){
            const arrayOld = arrayHistory.slice(MAX_HISTORY_CARD_COUNT,(arrayHistory.length - MAX_HISTORY_CARD_COUNT));
            for (let i=0;i<arrayOld.length;i++){
                await deleteLibraryHistory(arrayOld[i].id);
            }
        }

        if (arrayHistory.length > 0){
            resolve((Date.now() - arrayHistory[0].historyTime) > HISTORY_RECORD_TIME);
        }else{
            resolve(true);
        }
    })
}

/**
 * 更新历史记录
 * @param card
 * @param doc
 */
export const updateHistory = async (card:any,doc:any)=>{
    const bNeedSave = await hasBeyondLastestTime(card.id);
    if (bNeedSave){
        var newCard = {...card,doc};
        newCard.libraryId = card.id;
        delete newCard.id;
        delete newCard.isHover;
        delete newCard.isSelected;

        newCard.historyTime = Date.now();
        mLibraryHistory.put(newCard)
    }
}

/**
 * 删除历史记录
 * @param id
 */
export const deleteLibraryHistory = async (id:any)=>{
    mLibraryHistory.delete(id);
}

/**
 * 历史记录
 * @param szId
 */
export const libraryHistoryList = (szId:any)=>{
    if (!szId){//日记部分。日记有些没有被保存。显示历史随便一个值。空的
        szId = 'nothing'
    }
    return mLibraryHistory.where('libraryId').equals(szId).toArray();
}

export const historyByFormatDate = async (date)=>{
    const szDate = formatDate(date,'yyyyMMdd');
    let arrayCards = await mLibraryHistory.where({type:'journal','formatDate':szDate}).toArray();
    if (arrayCards.length > 0){
        return arrayCards[0].libraryId;
    }
    return null;
}

/***********************历史记录*end******************************/























